import svgPaths from "./svg-6pshef5ucc";

const fmt = (date?: string) =>
  date ? new Date(date).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—";

const statusConfig: Record<string, { bg: string; text: string; border: string; label: string }> = {
  selected:            { bg: "bg-[#e6fbf7]", text: "text-[#00828e]", border: "border-[rgba(0,130,142,0.2)]",  label: "Selected" },
  under_mentor_review: { bg: "bg-[#fff4e6]", text: "text-[#be4d00]", border: "border-[rgba(190,77,0,0.2)]",  label: "Under Review" },
  submitted_final:     { bg: "bg-[#e6f4ff]", text: "text-[#0058ab]", border: "border-[rgba(0,88,171,0.2)]",  label: "Submitted" },
  submitted_initial:   { bg: "bg-[#e6f4ff]", text: "text-[#0058ab]", border: "border-[rgba(0,88,171,0.2)]",  label: "Submitted" },
  rejected:            { bg: "bg-[#ffe8e6]", text: "text-[#8f3237]", border: "border-[rgba(143,50,55,0.2)]", label: "Rejected" },
};

function DocIcon() {
  return (
    <div className="relative shrink-0 size-[20px]">
      <svg className="absolute block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 20 20">
        <g>
          <path d={svgPaths.p3713e00} stroke="#0058AB" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.66667" />
          <path d={svgPaths.pd2076c0} stroke="#0058AB" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.66667" />
          <path d="M8.33333 7.5H6.66667" stroke="#0058AB" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.66667" />
          <path d="M13.3333 10.8333H6.66667" stroke="#0058AB" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.66667" />
          <path d="M13.3333 14.1667H6.66667" stroke="#0058AB" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.66667" />
        </g>
      </svg>
    </div>
  );
}

interface Props { idea: any; onClose: () => void; }

export default function PopupModal({ idea, onClose }: Props) {
  const s = statusConfig[idea.status] ?? statusConfig["submitted_initial"];

  return (
    <div className="bg-white overflow-clip relative rounded-[16px] shadow-[0px_25px_50px_-12px_rgba(0,0,0,0.25)] size-full flex flex-col">
      {/* Header */}
      <div className="absolute bg-white content-stretch flex flex-col items-start left-0 pb-[0.667px] pt-[16px] px-[32px] top-0 w-full z-10">
        <div aria-hidden="true" className="absolute border-[rgba(29,184,242,0.2)] border-b-[0.667px] border-solid inset-0 pointer-events-none" />
        <div className="content-stretch flex h-[65.333px] items-start justify-between relative shrink-0 w-full">
          <div className="flex-[1_0_0] min-h-px min-w-px flex flex-col gap-[8px]">
            <p className="font-bold leading-[28px] text-[#121a38] text-[20px] truncate">{idea.title}</p>
            <div className="flex gap-[16px] items-center">
              <div className="flex gap-[8px] items-center">
                <div className="relative shrink-0 size-[16px]">
                  <svg className="absolute block size-full" fill="none" viewBox="0 0 16 16">
                    <path d="M5.33333 1.33333V4" stroke="#0058AB" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33333" />
                    <path d="M10.6667 1.33333V4" stroke="#0058AB" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33333" />
                    <path d={svgPaths.p3ee34580} stroke="#0058AB" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33333" />
                    <path d="M2 6.66667H14" stroke="#0058AB" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.33333" />
                  </svg>
                </div>
                <p className="font-normal leading-[20px] text-[#4a5565] text-[14px] whitespace-nowrap">{fmt(idea.submittedAt)}</p>
              </div>
              <div className={`${s.bg} relative rounded-[22369600px] shrink-0 px-[16.667px] py-[6.667px]`}>
                <div aria-hidden="true" className={`absolute ${s.border} border-[0.667px] border-solid inset-0 pointer-events-none rounded-[22369600px]`} />
                <p className={`font-semibold leading-[16px] ${s.text} text-[12px] whitespace-nowrap`}>{s.label}</p>
              </div>
            </div>
          </div>
          <div onClick={onClose} className="relative rounded-[10px] shrink-0 size-[40px] cursor-pointer hover:bg-gray-100 transition-colors">
            <div className="content-stretch flex flex-col items-start pt-[8px] px-[8px] relative size-full">
              <div className="h-[24px] overflow-clip relative shrink-0 w-full">
                <div className="absolute inset-1/4"><div className="absolute inset-[-8.33%]"><svg className="block size-full" fill="none" viewBox="0 0 14 14"><path d="M13 1L1 13" stroke="#4A5565" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" /></svg></div></div>
                <div className="absolute inset-1/4"><div className="absolute inset-[-8.33%]"><svg className="block size-full" fill="none" viewBox="0 0 14 14"><path d="M1 1L13 13" stroke="#4A5565" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" /></svg></div></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="flex-1 overflow-y-auto pt-[98px] pb-[69px]">
        <div className="content-stretch flex flex-col gap-[24px] items-start px-[32px] pt-[32px] pb-[32px] w-full">
          {/* Section header */}
          <div className="content-stretch flex gap-[12px] h-[46px] items-center pb-[2px] relative shrink-0 w-full">
            <div aria-hidden="true" className="absolute border-[#0058ab] border-b-2 border-solid inset-0 pointer-events-none" />
            <DocIcon />
            <p className="font-semibold leading-[28px] text-[#121a38] text-[18px] whitespace-nowrap">Idea Information</p>
          </div>

          {/* Hackathon + Submission Date */}
          <div className="gap-x-[16px] gap-y-[16px] grid grid-cols-[repeat(2,minmax(0,1fr))] relative shrink-0 w-full">
            <div className="bg-[#f9fafb] col-1 justify-self-stretch relative rounded-[14px] row-1 self-stretch shrink-0">
              <div className="content-stretch flex flex-col gap-[8px] items-start pt-[16px] px-[16px] pb-[16px] relative size-full">
                <p className="font-semibold leading-[16px] text-[#6a7282] text-[12px] tracking-[0.6px] uppercase">Hackathon</p>
                <p className="font-medium leading-[20px] text-[#121a38] text-[14px]">{idea.hackathonId?.title ?? "—"}</p>
              </div>
            </div>
            <div className="bg-[#f9fafb] col-2 justify-self-stretch relative rounded-[14px] row-1 self-stretch shrink-0">
              <div className="content-stretch flex flex-col gap-[8px] items-start pt-[16px] px-[16px] pb-[16px] relative size-full">
                <p className="font-semibold leading-[16px] text-[#6a7282] text-[12px] tracking-[0.6px] uppercase">Submission Date</p>
                <p className="font-medium leading-[20px] text-[#121a38] text-[14px] whitespace-nowrap">{fmt(idea.submittedAt)}</p>
              </div>
            </div>
          </div>

          {/* Idea Statement */}
          <div className="bg-[#f9fafb] relative rounded-[14px] shrink-0 w-full">
            <div className="content-stretch flex flex-col gap-[8px] items-start pt-[16px] px-[16px] pb-[16px] relative size-full">
              <p className="font-semibold leading-[16px] text-[#6a7282] text-[12px] tracking-[0.6px] uppercase">Idea Statement</p>
              <p className="font-normal leading-[22.75px] text-[#121a38] text-[14px]">{idea.problem}</p>
            </div>
          </div>

          {/* Solution */}
          <div className="bg-[#f9fafb] relative rounded-[14px] shrink-0 w-full">
            <div className="content-stretch flex flex-col gap-[12px] items-start pt-[16px] px-[16px] pb-[16px] relative size-full">
              <p className="font-semibold leading-[16px] text-[#6a7282] text-[12px] tracking-[0.6px] uppercase">Proposed Solution</p>
              <p className="font-normal leading-[22.75px] text-[#364153] text-[14px]">{idea.solution}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="absolute content-stretch flex h-[69px] items-start justify-end left-0 pb-px pl-px pr-[33px] pt-[15px] bottom-0 w-full">
        <div aria-hidden="true" className="absolute border border-[rgba(0,0,0,0.05)] border-solid inset-0 pointer-events-none shadow-[2px_4px_4px_0px_rgba(0,0,0,0.25),0px_3px_0px_0px_rgba(0,0,0,0.27)]" />
        <div
          onClick={onClose}
          className="bg-[#0058ab] h-[40px] relative rounded-[10px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] shrink-0 px-[24px] cursor-pointer hover:bg-[#004a91] transition-colors flex items-center"
        >
          <p className="font-semibold leading-[20px] text-[14px] text-center text-white whitespace-nowrap">Close</p>
        </div>
      </div>
    </div>
  );
}
